import React, { useContext, useEffect, useState, useCallback } from "react";
import Sidebar from "../../component/Sidebar/SideBar";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { useTranslation } from "react-i18next";
import { AuthUserContext } from "../../context/context";
import { toast } from "react-toastify";
import getTopupPurchasedList from "../../services/topup/getTopupPurchasedList";
import DataTables from "../../component/DataTable";
import { useLocation, useNavigate } from "react-router-dom";
import { images } from "../../utils/image";
import esimVaultSvg from "../../assets/images/esimVault.svg";
import airaloSvg from "../../assets/images/airalo.svg";
import esimgoSvg from "../../assets/images/esimgo.svg";
import MonthSelector from "../../component/MonthFilter";
import Search from "../../component/Search";
import { SIM_PURCHASE, TOPUP } from "../../constants/localstorageKeys";
import DateFilter from "../../component/DateFilter";
import ApplyFilterButton from "../../component/ApplyFilter";
const TopUpListing = () => {
  const { t } = useTranslation();
  const { currentLocalization, setToastId, user, setUser } = useContext(AuthUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [topups, setTopups] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [sortedUsers, setSortedUsers] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('null');
  const [minDate, setMinDate] = useState("");
  const [showDiscountColumn, setShowDiscountColumn] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [appliedStartDate, setAppliedStartDate] = useState('');
  const [appliedEndDate, setAppliedEndDate] = useState('');
  const handleSearchChange = (newSearchValue) => {
    getTopUpListing(newSearchValue);
    setSearch(newSearchValue);
  };
  const handleApplyFilter = () => {
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
  };

  useEffect(() => {
    getTopUpListing(appliedStartDate, appliedEndDate);
  }, [appliedStartDate, appliedEndDate]);
  const getTopUpListing = async (startDate = null, endDate = null, search = "") => {
    try {
      const response = await getTopupPurchasedList({ startDate, endDate, search });
      setTopups(response.data?.topups);
      setStartDate(response.data.startDate);
      setEndDate(response.data.endDate);
      if(!minDate) setMinDate(response.data.startDate)
      if (!appliedStartDate && !appliedEndDate) {
        setStartDate(response.data.startDate);
        setEndDate(response.data.endDate);
      }
      const hasNullParentId = response.data?.topups.some(row => row?.userId?.parent_id === null);
      setShowDiscountColumn(!hasNullParentId);
      setSortedUsers(response.data?.topups);
    } catch (err) {
      const userDetails = JSON.parse(localStorage.getItem("USER_DETAILS"));
      const userRole = userDetails?.role;
      if (userRole === "user") {
        navigate("/data-usage");
        return;
      }
      if (userRole === "member") {
        navigate("/content-management");
        return;
      }
      if (err.response?.status == 401) {
        const id = toast.error(t("toastsMessage.part4"), {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true
        });
        setToastId(id);
        window.scroll(0, 0);
        localStorage.clear();
        navigate("/log-in");
      } else {
        console.log("err", err);
        const id = toast.error(err.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true
        });
        setToastId(id);
      }
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      name: <span className="dataTable-text">{t("table.vendor")}</span>,
      key: "vendorType",
      cell: (row) => (
        <div className="text-start column-text d-flex align-items-center">
          <div className="" style={{ width: "55px" }}>
            <img
              src={
                row?.vendorType == "esimgo"
                  ? esimgoSvg
                  : row?.vendorType === "esimVault"
                    ? esimVaultSvg
                    : airaloSvg
              }
              alt="offer-icon"
              width={40}
            />
          </div>
          <span className="ms-2">{row?.vendorType}</span>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: <span className="dataTable-text">{t("table.simid")}</span>,
      key: "iccid",
      selector: (row) => (
        <span className="text-start column-text">{row?.iccid}</span>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: <span className="dataTable-text">{t("table.username")}</span>,
      key: "userId.name",
      selector: (row) => (
        <span className="text-start column-text">{row?.userId?.name ?? row?.name}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: <span className="dataTable-text">{t("table.email")}</span>,
      key: "userId.email",
      selector: (row) => (
        <span className="text-start column-text">{row?.userId?.email ?? row?.email}</span>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: <span className="dataTable-text">{t("topup.package")}</span>,
      key: "package",
      cell: (row) => (
        <span
          className="text-start column-text"
          style={{ color: "black", fontSize: "16px", fontWeight: "500" }}
        >
          {row.package && row.package?.length > 35
            ? `${row.package.slice(0, 35)}...`
            : row.package}
        </span>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: <span className="dataTable-text">{t("topup.data")}</span>,
      key: "data",
      selector: (row) => (
        <span className="text-start column-text">
          {row?.data.replace("GB", "").trim() > 0 ? row?.data.replace("GB", "").trim() : t("home.part33")} {row?.data.replace("GB", "").trim() > 0 && t("home.part22")}
        </span>
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: <span className="dataTable-text">{t("topup.validity")}</span>,
      key: "validity",
      selector: (row) => (
        <span className="text-start column-text">
          {row?.validity} {t("home.part21")}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: <span className="dataTable-text">{!showDiscountColumn ? t("table.Price") : t("table.Price")}</span>,
      key: "price",
      selector: (row) => (
        <span className="text-start column-text">
          $ {row?.price.toFixed(2)}
        </span>
      ),
      sortable: true,
      width: "180px",
    }, 
    // {
    //   name: <span className="dataTable-text">{t("table.Discount")}</span>,
    //   key: "price",
    //   selector: (row) => (
    //     <span className="text-start column-text">
    //       {row.discountedPer ? row.discountedPer + "%" : '-'}</span>

    //   ),
    //   sortable: true,
    //   width: "120px",
    //   omit: showDiscountColumn
    // },
    // {
    //   name: <span className="dataTable-text">{t("table.Price")}</span>,
    //   key: "price",
    //   selector: (row) => (
    //     <span className="text-start column-text">
    //       $ {(row?.discountedPrice ? parseFloat(row?.discountedPrice).toFixed(2) : parseFloat(row?.price).toFixed(2))}
    //     </span>
    //   ),
    //   sortable: true,
    //   width: "120px",
    //   omit: showDiscountColumn
    // },
    // {
    //   name: <span className="dataTable-text">{t("topup.code")}</span>,
    //   selector: (row) => row?.code,
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: <span className="dataTable-text">{t("table.timestamps")}</span>,
      key: "createdAt",
      selector: (row) => (
        <span className="text-start column-text">
          {new Date(row.createdAt).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </span>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: <span className="dataTable-text">{t("table.expiration")}</span>,
      selector: (row) => (
        <span className="text-start column-text">
          {new Date(
            new Date(row.created_at).getTime() +
            row.validity * 24 * 60 * 60 * 1000
          ).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </span>
      ),
      // sortable: true,
      width: "200px",
    },
  ];
  const handleSort = async (column, direction) => {
    const nestedSort = (obj, path) => {
      const value = path
        .split(".")
        .reduce(
          (value, key) =>
            value && value[key] !== undefined ? value[key] : null,
          obj
        );
      if (path === "data") {
        return parseFloat(value.replace("GB", "").trim());
      }

      return value;
    };

    const sortedData = [...topups].sort((a, b) => {
      const aValue = nestedSort(a, column.key);
      const bValue = nestedSort(b, column.key);

      if (aValue < bValue) {
        return direction === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    setSortedUsers(sortedData);
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    localStorage.removeItem("OUTSIDER_USER");
    if (params.get("payment_success")) {
      localStorage.setItem(TOPUP, "true");
      window.dispatchEvent(new Event("topup-storage-change"));
      const id = toast.success(t("toastsMessage.part1"), {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        pauseOnHover: true
      });
      setToastId(id);
      params.delete("payment_success");
      navigate(location.pathname, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);
  useEffect(() => {
    getTopUpListing();
  }, [currentLocalization, selectedMonth]);

  return (
    <Sidebar>
      <Container>
        <Row className="d-flex align-items-center justify-content-between">
        
          <Col xs="auto">
            <div
              className={
                currentLocalization === "ar" ? "text-end" : "text-start"
              }
            >
              <h2 className="package-h2">{t("dataUsage.topupListing")}</h2>
            </div>
          </Col> 
          <Col xs="auto" className="d-flex justify-content-end  align-items-center gap-2 flex-wrap" >
          {user && user.role === 'partner' && (<>
            <DateFilter
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              initialStartDate={startDate}
              initialEndDate={endDate}
              minDate={minDate}
            />
            <ApplyFilterButton onApply={handleApplyFilter} />
            </>)}
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="mt-4">
              <DataTables
                columns={columns}
                data={sortedUsers.length ? sortedUsers : topups}
                loading={loading}
                handleSort={handleSort}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </Sidebar>
  );
};

export default TopUpListing;
